import React from 'react';

import './TrackList.css';


import TrackResult from './TrackResult';



function TrackListResult( {tracks}) {

  




        return (

            <div class="TrackList">
              {
           
         
                /* use the .map() method to render each track in the tracks property */
          tracks.map(tracknamehierdefiniert_proelement => {
         return   <TrackResult track={tracknamehierdefiniert_proelement}  
                   key={tracknamehierdefiniert_proelement.id} 
                   
                 
                    // diese nicht    onAdd={this.props.onAdd}
                    // diese nicht    onRemove={this.props.onRemove}
                    // diese nicht    isRemoval={this.props.isRemoval}
                    
                    />
           
                    
           
           })
        }
  
            </div>


        )


    }




export default TrackListResult;